export default __webpack_public_path__ + "static/media/22.b40e5a40.mp3";